export const identityConfig = {
  region: process.env.VUE_APP_COGNITO_REGION,
  IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_ID,
  UserPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
  CognitoIdp: `cognito-idp.${process.env.VUE_APP_COGNITO_REGION}.amazonaws.com/${process.env.VUE_APP_COGNITO_USERPOOL_ID}`,
};
